import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRoute = ({ element }: ProtectedRouteProps) => {
  const token = localStorage.getItem('access_token');
  return token ? element : <Navigate to="/login" replace />;
};

export default ProtectedRoute;